import { CloseOutlined } from "@ant-design/icons";
import { Col, Row, Typography } from "antd";
import React from "react";
import "./fileInfo.scss";

interface FileInfoProps {
  handleCancel: () => void;
  file: File;
}
const FileInfo: React.FC<FileInfoProps> = ({ handleCancel, file }) => {
  return (
    <section className="uploaded_file_preview">
      <Row className="uploaded_fileInfo">
        <Col className="svg_conatiner">
          <img src="/assets/pdf_logo.svg" alt="PDF Logo" className="svg-icon" />
        </Col>
        <Col className="uploaded_filename">
          <Typography.Text>{file.name}</Typography.Text>
        </Col>
        <Col flex="auto"></Col>
        <Col className="uploaded_filename">
          <CloseOutlined onClick={handleCancel} className="close_btn" />
        </Col>
      </Row>
    </section>
  );
};

export default FileInfo;
